var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2705 2.5C13.5242 2.5 11.2978 4.65566 11.2978 7.31481V10.6482H19.9044V11.5741H7.4727C4.72637 11.5741 2.50003 13.7298 2.50003 16.3889V23.6111C2.50003 26.2703 4.72637 28.4259 7.4727 28.4259H10.3416V24.3519C10.3416 21.6928 12.5679 19.537 15.3143 19.537H24.4945C26.8184 19.537 28.7022 17.713 28.7022 15.463V7.31481C28.7022 4.65566 26.4759 2.5 23.7295 2.5H16.2705ZM15.123 8.42593C16.0737 8.42593 16.8443 7.67973 16.8443 6.75926C16.8443 5.83879 16.0737 5.09259 15.123 5.09259C14.1723 5.09259 13.4017 5.83879 13.4017 6.75926C13.4017 7.67973 14.1723 8.42593 15.123 8.42593Z",
    fill: "url(#paint0_linear_2272_4032)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7293 37.5C26.4757 37.5 28.702 35.3444 28.702 32.6852V29.3519H20.0954V28.426H32.5272C35.2735 28.426 37.4998 26.2703 37.4998 23.6111V16.3889C37.4998 13.7298 35.2735 11.5741 32.5272 11.5741H29.6583V15.6481C29.6583 18.3074 27.4319 20.463 24.6857 20.463H15.5053C13.1814 20.463 11.2976 22.287 11.2976 24.537V32.6852C11.2976 35.3444 13.524 37.5 16.2703 37.5H23.7293ZM24.8769 31.5741C23.9262 31.5741 23.1555 32.3203 23.1555 33.2408C23.1555 34.1613 23.9262 34.9074 24.8769 34.9074C25.8275 34.9074 26.5982 34.1613 26.5982 33.2408C26.5982 32.3203 25.8275 31.5741 24.8769 31.5741Z",
    fill: "url(#paint1_linear_2272_4032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2272_4032",
    x1: 15.6012,
    y1: 2.5,
    x2: 15.6012,
    y2: 28.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2272_4032",
    x1: 24.3988,
    y1: 11.5741,
    x2: 24.3988,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon08);
export default __webpack_public_path__ + "assets/media/project-icon08.aa0ac669e9fe35f0a8fb174c71919e70.svg";
export { ForwardRef as ReactComponent };